import { defineObstacle } from '../schema';

/* ═══════════════════════════════════════════════════════════════════════════
   BLOC — l'astéroïde moyen, destructible mais coûteux.

   140 PV : ~0,7 s de tir soutenu, assez pour qu'on ait à CHOISIR entre le faire
   sauter et le contourner. C'est le grain de la décision — trop dur pour
   disparaître tout seul comme l'Éclat, trop tendre pour être un mur comme le
   Colosse. Un joueur qui insiste dessus paie en temps d'exposition ; un joueur
   qui l'esquive garde son tir pour les ennemis. Les deux sont des jeux valides,
   et c'est exactement ce qu'un obstacle destructible doit produire.
   ═══════════════════════════════════════════════════════════════════════════ */

export default defineObstacle({
  id: 'astero-bloc',
  radius: 42,
  hp: 140,
  destructible: true,
  score: 60,
});
